import { render, staticRenderFns } from "./Info.svg.vue?vue&type=template&id=489bf116"
import script from "./Info.svg.vue?vue&type=script&lang=ts"
export * from "./Info.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489bf116')) {
      api.createRecord('489bf116', component.options)
    } else {
      api.reload('489bf116', component.options)
    }
    module.hot.accept("./Info.svg.vue?vue&type=template&id=489bf116", function () {
      api.rerender('489bf116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/common/Info.svg.vue"
export default component.exports